// Đánh dấu thông báo cá nhân đã đọc (notification-service MarkNotificationsRead — POST /notifications/read { ids } | { all }):
// bấm một thông báo trong menu chuông ⇒ đọc mục đó; "Đánh dấu đã đọc" ⇒ đọc tất cả. Làm mới danh sách + số chưa đọc.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { notification } from '@cathouse/contracts';
import { http, qk } from '@/shared/api';

export type MarkReadInput = { ids: string[] } | { all: true };

export function useMarkNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: MarkReadInput) => http.post<notification.MarkNotificationsReadResult>('/notifications/read', v),
    onSuccess: (r) => {
      // Số chưa đọc trả về ngay trong kết quả ⇒ chấm số của chuông đổi không chờ tải lại
      if (typeof r?.unread === 'number') qc.setQueryData<notification.UnreadNotificationCount>(qk.notifications.unread(), { unread: r.unread });
      return qc.invalidateQueries({ queryKey: qk.notifications.all });
    },
  });
}
